// import taxSubmissions from './tax-submissions.js';
import taxReturns from './tax-returns.js';
import taxBills from './tax-bills.js';

export default [
    // ...taxSubmissions,
    ...taxReturns,
    ...taxBills,
];
